import type { FeedbackContext } from "@demo/features/report";
import { useMediaStore } from "@demo/store/media";
import { useModelStore } from "@demo/store/model";

/**
 * Snapshot the compose run for a feedback report: the request that produced
 * the output, the streamed text, and the media inserted in the editor.
 */
export const composeFeedbackContext = (): FeedbackContext => {
  const { lastRequest, agentText } = useModelStore.getState();
  const mediaUrls = useMediaStore
    .getState()
    .mediaSets.flatMap((set) => set.media.map((m) => m.url).filter((u): u is string => !!u));

  return {
    mode: "compose",
    requestBody: lastRequest ?? null,
    modelResponse: agentText ?? "",
    mediaUrls,
  };
};
